export const CALLER_TIMEZONE_HEADER = "x-inference-caller-timezone";

function isValidTimeZone(timeZone: string): boolean {
  try {
    new Intl.DateTimeFormat("en-US", { timeZone }).format(new Date(0));
    return true;
  } catch {
    return false;
  }
}

export function normalizeCallerTimezone(
  timeZone: string | null | undefined,
): string | null {
  const trimmed = timeZone?.trim();
  if (!trimmed) return null;
  return isValidTimeZone(trimmed) ? trimmed : null;
}

export function getCallerTimezoneFromHeaders(headers: Headers): string | null {
  return normalizeCallerTimezone(headers.get(CALLER_TIMEZONE_HEADER));
}

function getRuntimeCallerTimezone(): string | null {
  return normalizeCallerTimezone(
    Intl.DateTimeFormat().resolvedOptions().timeZone,
  );
}

export function createCallerTimezoneHeaders(): Record<string, string> {
  const timeZone = getRuntimeCallerTimezone();
  return timeZone ? { [CALLER_TIMEZONE_HEADER]: timeZone } : {};
}
